import React from 'react'
import Progressbar from './Progressbar'
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

function Ieee_banner() {
  return (
    <div className="container">
        <div class="row">
            <div class="col-sm-6 mb-3 mb-sm-0">
                <div className="container my-5 d-flex justify-content-center">
                <motion.div
                className="card shadow-lg"
                style={{ width: '38rem', overflow: 'hidden', background: 'None' }}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.6, ease: 'easeOut' }}
                >
                <div class="card-body">
                    <h2 class="card-title text-danger border-bottom">Indexing and Publishing</h2>
                    <p class="card-text">Accepted papers will be submitted for inclusion into IEEE Xplore subject to meeting IEEE Xplore’s scope and quality requirements.</p>
                    <h5 className="card-title border-bottom my-4">Submit your paper</h5>
                    <p className="card-text">Click on the below link to submit your paper</p>
                    <a href="https://cmt3.research.microsoft.com/NETCRYPT2026" type="button" class="btn btn-primary border-0" target="_blank" style={{background:"rgb(0,126,123)"}}>NETCRYPT 2026</a>

                    <p className="card-text my-3">Click on the below link to get the steps for submission.</p>
                    <Link to="/submission" type="button" class="btn btn-outline-primary">How to Submit</Link>
                    
                </div>
                </motion.div>
                </div>
            </div>
            <div class="col-sm-6">
                <Progressbar />
            </div>
            </div>
    </div>
  )
}

export default Ieee_banner